<template>
  <div class="st-model">
    <div class="st-model-container">
      <div class="modal-headline">
        <img class="button-close" src="~images_base/close.svg" alt="close button" @click="closeModel">
        <div class="headline">

        </div>
      </div>
      <div class="modal-body">
        <div :class="['cabinet-member-detail', checkCircleStatus(content.change_new_retire)]">
          <div class="cabinet-member-photo">
            <img :src="getImgUrl(content.img_name)" :alt="content.img_name" />
            <div class="change_new_retire_text text_new">New MP</div>
            <div class="change_new_retire_text text_change">New NCMP</div>
            <!-- <div class="change_new_retire_text text_retire">Outgoing</div> -->
            <!-- <div class="change_new_retire_text text_new-office">New office-holder</div> -->
          </div>
          <h4 class="name">{{content.name}}</h4>
          <div class="cabinet-member-content">
            <div class="left-col">
              <div class="data-field designation" v-if="content.designation" v-markdown="content.designation"></div>
              <div class="data-field" v-if="content.age || content.yr_experience">
                <p v-if="content.party && content.party !== '-'"><strong>Industry</strong><br>{{content.party}}</p>
                <p v-if="content.age && content.age !== '-'"><strong>Age</strong><br>{{content.age}}</p>
                <!-- <p v-if="content.yr_experience && content.yr_experience !== '-'"><strong>Years In Politics</strong><br>{{content.yr_experience}}</p> -->
                <p v-if="content.constituency && content.constituency !== '-'"><strong>Country/territory</strong><br>{{content.constituency}}</p>
              </div>
              <!-- <div class="data-field" v-if="content['ministry-1'] && content['ministry-1'] !== '-'">
                <p>
                  <strong>Ministry</strong>
                  <template v-if="content['ministry-1'] && content['ministry-1'] !== '-'"><br>{{content['ministry-1']}}</template>
                  <template v-if="content['ministry-2'] && content['ministry-2'] !== '-'"><br>{{content['ministry-2']}}</template>
                  <template v-if="content['ministry-3'] && content['ministry-3'] !== '-'"><br>{{content['ministry-3']}}</template>
                </p>
              </div> -->
            </div>
            <div class="right-col" v-markdown="content.previous_portfolio"></div> 
            <!-- <div class="quote" v-if="content.quote"> -->
              <!-- <q class="sidebar-quotebox">{{content.quote}} </q> -->
              <!-- <div class="more-info">Issues the MP plans to speak on</div> -->
          </div>
          </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {store} from './ProjectStore.js'
export default {
  props: ['content'],
  methods: {
    closeModel () {
      store.modelData = null
      document.querySelector('body').style.overflow = ''
    },
    getImgUrl (url) {
      if (url === '-' || url === '') {
        return require(`images/project/head/default.png`)
      }
      return require(`images/project/head/${url}.jpg`) // using pix in local folder
      // var imagesAssetFolder = store.imagesAssetFolder
      // return require(`${imagesAssetFolder}/candidates/${url}.jpg`)
      // return `${imagesAssetFolder}/${url.trim()}.jpg`
    },
    checkCircleStatus (status) {
      if (status && status !== '' && status !== '-') {
        return `circle_${status}`
      }
    }
  }
}
</script>

<style lang="scss">
.st-model {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  z-index: 100000;
  @include breakpoint($d_small) {
    background-color: rgba(#000000, 0.3);
  }

  .st-model-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #FFFFFF;
    text-align: center;
    overflow: hidden;
    width: 100%;
    height: 100%;
    max-width: 800px;
    max-height: 100%;
    padding-bottom: 10px;
    @include breakpoint($d_small - 1) {
      border-radius: 10px;
      width: calc(100% - 40px);
      height: auto;
      // overflow: auto;
      max-height: calc(80% - 40px);
    }
    // @media (max-width: $d_small) {
      
    // }
    .modal-headline {
      // background-color: $screen;
      position: fixed;
      width: 100%;
      top: 0;
      left: 0;
      @include breakpoint($d_small) {
        background-color: #FFFFFF;
        position: relative;
        min-height: 45px;
      }
      .button-close {
        position: absolute;
        z-index: 1;
        padding: 5px;
        border: 1px solid $black;
        border-radius: 50%;
        cursor: pointer;
        pointer-events: all;
        top: 50%;
        transform: translateY(-50%);
        right: 5px;

        @include breakpoint($d_small) {
          display: block;
          top: 10px;
          right: 10px;
          transform: none;
        }
      }
      .headline {
        max-width: 90%;
        min-height: 50px;
        padding: 20px 20px 10px 20px;
        font-family: $font-CuratorBold;
        box-sizing: border-box;
        img {
          height: 30px;
          margin-right: 5px;
          vertical-align: middle;
        }
      }
    }
    .modal-body {
      overflow: auto;
      max-height: 100%;
      padding: 50px 16px 16px;
      box-sizing: border-box;
      text-align: left;
      @include breakpoint($d_small) {
        padding: 0 20px 20px;
        max-height: calc(80vh - 75px);
      }
      .cabinet-member-detail {
        margin: 0 auto;
        @media (min-width: $d_medium) {
          max-width: 90%;
        }
        &.circle_new {
          // $item_color: #B20016;
          $item_color: #DF8526;
          .cabinet-member-photo {
            // max-width: 200px;
            margin: 0 auto;
            img {
              border-color: $item_color;
              box-shadow: inset 0 0 5px 15px $item_color;
            }
            .text_new {
              display: block;
              background-color: $item_color;
              white-space: nowrap;
            }
          }
        }
        &.circle_change {
          $item_color: #DF8526;
          .cabinet-member-photo {
            img {
              border-color: $item_color;
              box-shadow: inset 0 0 5px 15px $item_color;
            }
            .text_change {
              display: block;
              background-color: $item_color;
              white-space: nowrap;
            }
          }
        }
        &.circle_retire {
          $item_color: #5D9DD4;
          .cabinet-member-photo {
            img {
              border-color: $item_color;
              box-shadow: inset 0 0 5px 15px $item_color;
            }
            .text_retire {
              display: block;
              background-color: $item_color;
              white-space: nowrap;
            }
          }
        }
        &.circle_new-office {
          $item_color: #EF4223;
          .cabinet-member-photo {
            img {
              border-color: $item_color;
              box-shadow: inset 0 0 5px 15px $item_color;
            }
            .text_new-office {
              display: block;
              background-color: $item_color;
              white-space: nowrap;
            }
          }
        }
      }
      .cabinet-member-photo {
        position: relative;
        max-width: 200px;
        margin: 0 auto;
        img {
          max-width: 100%;
          display: block;
          margin: 0 auto 20px;
          border: 4px solid transparent;
          border-radius: 50%;
          box-sizing: border-box;
        }
        .change_new_retire_text {
          position: absolute;
          top: 15px;
          right: 0;
          font-family: $font-CuratorRegular;
          color: #fff;
          font-size: 15px;
          text-transform: uppercase;
          padding: 2px 10px;
          display: none;
          // @media (max-width: $d_medium - 1) {
          //   bottom: -53px;
          //   top: auto;
          //   font-size: 12px;
          //   padding: 0 2px;
          //   left: 0;
          //   right: 0;
          //   text-align: center;
          // }
        }
      }
      .name {
        font-family: $font-CuratorBold;
        text-align: center;
        margin-bottom: 20px;
      }
      .cabinet-member-content {
        border-top: 0.75px dotted #c0cac9;
        padding: 20px 10px 0;
        box-sizing: border-box;
        p {
          margin-bottom: 20px;
          &:last-child {
            margin-bottom: 0;
          }
        }
        .left-col {
          margin-bottom: 40px;
          padding-right: 0;
        }
        .right-col {
          padding-left: 0;
        }
        .quote{
          max-width: 700px;
          text-align: left;
          margin-top: 40px;
          font-family: $font-SelaneTwenty;
          color: #333;
          font-size: 23px;
          line-height: 33px;
          position: relative;
          word-break: break-word;
          font-size: 30px;
          line-height: 34px;
          display: none;
            ::after {
              content: "\201D";
              display: block;
              color: #9da6b0;
              font-family: $font-SelaneForty;
              font-size: 160px;
              font-weight: normal;
              line-height: 116px;
              height: 60px;
              bottom: -70px;
              position: absolute;
              left: 0px;              
            }
            .more-info {
            font-family: $font-CuratorRegular;
            font-size: 16px;
            line-height: 32px;
            color: #9d9d9d;
            }
          }
        @media (min-width: $d_medium) {
          .left-col, .right-col {
            display: inline-block;
            vertical-align: text-top;
            box-sizing: border-box;
          }
          .left-col {
            width: 40%;
            padding-right: 20px;
            margin-bottom: 0;
          }
          .right-col {
            width: 60%;
            padding-left: 20px;
          }
          }
        }
        .data-field {
          display: block;
          margin-bottom: 20px;
          &:last-child {
            margin-bottom: 0;
          }
          & > * {
            display: block;
            @media (max-width: $d_medium - 1) {
              display: inline-block;
              width: 100%;
            }
          }
          &.designation {
            font-family: $font-CuratorRegular;
            text-transform: uppercase;
            font-size: 17px;
            line-height: 22px;
          }
          strong {
            font-family: $font-CuratorRegular;
            text-transform: uppercase;
          }
          p {
            font-family: $font-CuratorBold;
            font-size: 17px;
            line-height: 22px;
            margin-bottom: 5px;
          }
        }
      }



    }
  }
</style>
